import { startsWithPostalCode } from "../utilities/index.js";

const placesAutocomplete = (options) => ({

    query: '',
    selected: null,
    items: [],
    placeholder: options.placeholder,

    init() {

        if (!options.form) {
            throw new Error('No valid form provided.');
        }

        if (!options.targetInput) {
            throw new Error('No valid targetInput provided.');
        }

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });

        if (params.location) {

            this.selected = {
                place: params.location
            };

            const input = document.querySelector(options.targetInput);
            input.value = params.location;

            this.placeholder = params.location;
        }

        this.$watch('selected', () => {
            this.$dispatch('place-selected', { data: this.selected });
        });
    },

    requestSubmit() {
        if (this.startsWithPostalCode(this.query)) {
            this.selected = {
                place: this.query
            };
        }

        const form = document.querySelector(options.form);
        if (form) {
            form.requestSubmit();
        }
    },

    startsWithPostalCode(value) {
        return startsWithPostalCode(value);
    },

    reset() {
        this.query = '';
        this.selected = null;
        this.items = [];
        this.placeholder = options.placeholder;

        document.querySelector(options.form).location.value = this.query;

        this.$nextTick(() => {
            this.requestSubmit();
        });
    },

    search() {
        const { geocodingService } = __appConfiguration;

        if (this.query.length > 2 && !startsWithPostalCode(this.query)) {
            fetch(`${geocodingService.baseUrl}/api/places/suggest?query=${this.query}`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'ApiKey': geocodingService.apiKey,
                },
            })
                .then((response) => { return response.json(); })
                .then((data) => { this.items = data; });
        }

        if (startsWithPostalCode(this.query)) {

            this.items = [];
            this.items.push({ place: this.query });

            this.selected = {
                place: this.query,
            };

            document.querySelector(options.form).location.value = this.query;
        }
    },

    get results() {
        return this.items;
    }

});

export { placesAutocomplete };
